import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useUserData from "../hooks/useUserData";
import MUIDataTable from "mui-datatables";
import "./css/CustomLook.css";
import StatusModule from "./StatusModule";



const resourceCategories = {
  "white": ["Metals", "Baobabs", "Silicon", "Space Oats", "Nuclear Waste"],
  "#40BF00": ["Petroleum", "Vis", "Jelly Beans", "Copper", "Tin", "Silver", "Titanium", "Psion Icicles"],
  "#007FFC": ["Diamond", "Quantumum", "Alien Bacteria", "Enriched Nuclear Material", "Laconia", "Plasma Crystals", "Gold"],
  "#D86D00": ["Energon", "Dark Matter", "Frozen Blob", "Adamantium", "Rubicite", "Platinum", "Ablution Crystals", "Bacta", "Fermium", "Atmospheric Disturbances", "Dunes", "Roosts", "Trobbles", "Astral Worms"],
  "#992cff": ["Thickened Atmosphere", "Stabilized Weather", "Breathtaking Vistas", "Magnetic Miracle", "Biogeneticists Playground"],
  "#FE2712": ["Goop"]
};

const viewStatus = localStorage.getItem("userStatus");

if (viewStatus)
{
  console.log("View status returned as" + viewStatus);
}
else
{
  console.log("No view status variable found");
}

const getResourceColor = (resourceName) => {
  const normalizedName = resourceName.trim().toLowerCase();
  for (const [color, resources] of Object.entries(resourceCategories)) {
    if (resources.some(res => res.toLowerCase() === normalizedName)) {
      return color;
    }
  }
  return "white";
};

const TeamScans = () => {
  const navigate = useNavigate();
  const { userData, loading } = useUserData();
  const [scans, setScans] = useState([]);
  const [rows, setRows] = useState([]);
  const [includeTeamScans, setIncludeTeamScans] = useState(true);
  const [ownersMapping, setOwnersMapping] = useState({});
  const [teamsMapping, setTeamsMapping] = useState({});

    useEffect(() => {
        if (!loading) {
            if (!userData) {
                navigate("/starsonata"); 
            } else if (userData.teamId === "unassigned") {
                navigate("/join");
            } else if (!userData.verified) {
                navigate("/pending");
            }
        }
    }, [userData, loading, navigate]);

  // fetch scan data
  useEffect(() => {
    if (!loading && userData?.verified) {
      fetch("https://imp.slypandainteractive.com/galaxies")
        .then((res) => res.json())
        .then(setScans)
        .catch((err) => console.error("Error loading scans:", err));
    }
  }, [userData, loading]);

  // fetch ownership data
  useEffect(() => {
    fetch("/universe.json")
      .then((res) => res.json())
      .then((data) => {
        const mapping = {};
        if (data.galaxies) {
          Object.values(data.galaxies).forEach((g) => {
            if (g.name && g.owningTeamID) {
              mapping[g.name.trim().toLowerCase()] = g.owningTeamID;
            }
          });
        }
        setOwnersMapping(mapping);
      })
      .catch((err) => console.error("Error loading universe.json:", err));
  }, []);

  // fetch teams data
  useEffect(() => {
    fetch("/teams.json")
      .then((res) => res.json())
      .then((data) => {
        const mapping = {};
        if (data.teams) {
          Object.values(data.teams).forEach((team) => {
            if (team.teamID && team.name) {
              mapping[team.teamID] = team.name;
            }
          });
        }
        setTeamsMapping(mapping);
      })
      .catch((err) => console.error("Error loading teams.json:", err));
  }, []);

  // group scans
  useEffect(() => {
    const grouped = {};

    scans
      // .filter(scan => {
      //   const team = String(scan.upload_team ?? "0");
      //   const myTeam = String(userData?.teamId ?? "");
      //   return team === myTeam || (includeTeamScans && team === "1932");
      // })
      .forEach(scan => {
        if (!scan.galaxy || !scan.resource_name) return;

        const galaxy = scan.galaxy.trim();
        const resource = scan.resource_name.trim();
        const color = getResourceColor(resource);
        const total = scan.total_amount;
        const team = String(scan.upload_team ?? "0");

        if (!grouped[galaxy]) grouped[galaxy] = [];

        grouped[galaxy].push({
          resource,
          total,
          color,
          upload_team: team
        });
      });



    const tableRows = Object.entries(grouped).map(([galaxy, resources]) => {
      const lowerGalaxy = galaxy.toLowerCase();
      const owningTeamId = ownersMapping[lowerGalaxy];
      const resourceStr = resources
        .map((r) => `<span style="color:${r.color}">${r.resource}: ${r.total}</span>`)
        .join(", ");
      return [owningTeamId, galaxy, resourceStr];
    });

    setRows(tableRows);
  }, [scans, includeTeamScans, userData, ownersMapping]);

  const columns = [
    {
      name: "Owner",
      options: {
        sort: false,
        filter: false,
        customBodyRender: (teamId) =>
          teamId && teamId !== "0" ? (
            <img
              src={`https://www.starsonata.com/images/team_flags/game/${teamId}`}
              alt={`Team ${teamId}`}
              title={teamsMapping[teamId] || `Team ${teamId}`}
              style={{ maxWidth: "40px", maxHeight: "40px" }}
            />
          ) : (
            "—"
          ),
      },
    },
    {
      name: "Galaxy",
    },
    {
      name: "Resources",
      options: {
        customBodyRender: (value) => (
          <span dangerouslySetInnerHTML={{ __html: value }} />
        ),
      },
    },
  ];

 columns.push({
   name: "",
   options: {
     filter: false,
     sort: false,
     setCellProps: () => ({ style: { textAlign: "center" } }),
     customBodyRenderLite: (dataIndex) => {
       const galaxy = rows[dataIndex][1];      
      if (userData.role === "leader") {
        return (
          <button
            className="back-button"
            onClick={() => handleDeleteGalaxy(galaxy)}
          >
            Delete
          </button>
        );
      }
      return null;
     }
   }
 });

  const options = {
    selectableRows: "none",
    elevation: 0,
    responsive: "standard",
    rowsPerPage: 100,
    onRowClick: (rowData) => {
      const galaxy = rowData[1];
      navigate(`/scandetails/${encodeURIComponent(galaxy)}`);
    },
    componentsProps: {
      tableHeadCell: {
        className: "custom-table-header"
      }
    },
    setRowProps: () => ({
      className: "custom-table-cell"
    }),
    setTableProps: () => ({
      className: "custom-table-root"
    }),
    textLabels: {
      body: {
        noMatch: "No scans found."
      }
    }
  };

const handleDeleteGalaxy = async (galaxy) => {
  const teamId = userData.teamId;       // ← Grab teamId here
  if (!window.confirm(`Are you sure you want to delete all ${teamsMapping[teamId]} scans in ${galaxy}? There is no undo button!`)) return;

  try {
    const res = await fetch(
      "https://imp.slypandainteractive.com/delete_entry.php",
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({ 
          galaxy, 
          teamId: String(teamId)        
        }),
      }
    );

    const text = await res.text();
    alert(text);
    setScans((prev) =>
      prev.filter(
        (s) => !(s.galaxy === galaxy && s.upload_team === String(teamId))
      )
    );
  } catch (err) {
    console.error("Error deleting galaxy entries:", err);
    alert("Failed to delete — something went wrong.");
  }
};


  return (
    <div >
      <h1 style={{ textAlign: "center" }}>Galaxy Scans ({viewStatus})</h1>
<StatusModule></StatusModule>

      <div style={{ display: "flex", justifyContent: "center" }}>
      <MUIDataTable
  title={null}
  data={rows}
  columns={columns}
  options={{
    ...options,
    setRowProps: () => ({
      className: "custom-table-cell",
    }),
    setTableProps: () => ({
      className: "custom-table-root",
    }),

  }}
/>
      </div>
    </div>
  );
};

export default TeamScans;
